/* eslint-disable no-nested-ternary */
// TODO: need to fix nested ternary
import React, { Component } from 'react';
import styled from 'styled-components';
import { Collapse } from 'react-collapse';
import Ingridient from '../../Common/Ingridient';
import ArrowBackIcon from '../../../images/arrow-black.png';

export default class SingleDish extends Component {
  state = {
    isOpened: false,
  };

  open = () => {
    const { isOpened } = this.state;
    this.setState({ isOpened: !isOpened });
  };

  renderIngridientsList = () => {
    const { meal } = this.props;
    const ingridients = meal.dish ? (meal.dish.recepie ? meal.dish.recepie.products : null) : null;

    if (ingridients) {
      return ingridients.map((ingridient) => (
        <Ingridient key={ingridient.id} ingridient={ingridient} />
      ));
    }
  };

  render() {
    const { meal } = this.props;
    const { isOpened } = this.props;
    const recepie = meal.dish
      ? meal.dish.recepie
        ? !meal.dish.recepie.text === '' && meal.dish.recepie.products.length !== 0
        : null
      : null;

    return (
      <SingleDishItem>
        <Name onClick={this.open}>
          {!!meal.dish && meal.dish.name}
          {recepie && (
            <ImgArrow src={ArrowBackIcon} alt="arrow" isOpened={isOpened} recepie={recepie} />
          )}
        </Name>
        <Stats>
          <StatItem>
            <StatName>к</StatName>
            <StatValue>
              {!!meal.dish && Math.round((meal.dish.recepie.calories / 100) * meal.quantity)}
            </StatValue>
          </StatItem>
          <StatItem>
            <StatName>б</StatName>
            <StatValue>
              {!!meal.dish && Math.round((meal.dish.recepie.proteins / 100) * meal.quantity)}
            </StatValue>
          </StatItem>
          <StatItem>
            <StatName>ж</StatName>
            <StatValue>
              {!!meal.dish && Math.round((meal.dish.recepie.fats / 100) * meal.quantity)}
            </StatValue>
          </StatItem>
          <StatItem>
            <StatName>у</StatName>
            <StatValue>
              {!!meal.dish && Math.round((meal.dish.recepie.carbohydrates / 100) * meal.quantity)}
            </StatValue>
          </StatItem>
        </Stats>
        {!!recepie && (
          <Collapse isOpened={isOpened}>
            <RecepieBlock>
              <Recepie>
                <Title>Рецепт</Title>
                {meal.dish ? (meal.dish.recepie ? meal.dish.recepie.text : null) : null}
              </Recepie>
              <IngridientList>
                <Title>Ингредиенты на 100г. блюда:</Title>
                {this.renderIngridientsList()}
              </IngridientList>
            </RecepieBlock>
          </Collapse>
        )}
      </SingleDishItem>
    );
  }
}

const SingleDishItem = styled.div`
  width: 100%;
  min-height: 80px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
`;

const Name = styled.div`
  position: relative;
  height: 80px;
  width: 40%;
  padding: 0 45px 0 15px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  background: 'fff';
  flex-flow: row nowrap;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ImgArrow = styled.img`
  position: absolute;
  right: 15px;
  bottom: 30px;
  width: 20px;
  height: 20px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(270deg)' : 'rotate(90deg)')};
`;

const Stats = styled.div`
  height: 80px;
  width: 60%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const StatItem = styled.div`
  height: 100%;
  width: 25%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
`;

const StatName = styled.div`
  height: 50%;
  min-height: 40px;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background: #e8e8e8;
`;

const StatValue = StatName.extend`
  text-transform: none;
  background: #fff;
`;

const RecepieBlock = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
`;

const Recepie = styled.div`
  box-sizing: border-box;
  width: 50%;
  padding: 20px 20px 20px 15px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const IngridientList = Recepie.extend``;

const Title = styled.h3`
  margin: 0 0 15px 0;
`;



// WEBPACK FOOTER //
// ./src/Components/Templates/TemplatesList/SingleDish.jsx